import { getPendingPayments } from './states';

export const services = {
  getPendingPayments,
};
